import type { SystemStyleInterpolation } from '@chakra-ui/react';

/**
 * Global styles for the Snaps Directory.
 */
export const global: SystemStyleInterpolation = {
  body: {
    color: 'text.default',
    background: 'background.default',
    overflowY: 'scroll',
  },
};
